import React from 'react';
import { SnackbarProvider as NotistackSnackbarProvider } from 'notistack';

export const SnackbarProvider = ({ children }) => {
  const domRootRef = React.useRef(null);

  React.useEffect(() => {
    domRootRef.current = document.createElement('div');
    document.body.appendChild(domRootRef.current);

    return () => {
      document.body.removeChild(domRootRef.current);
    };
  }, []);

  return React.createElement(
    NotistackSnackbarProvider,
    {
      maxSnack: 3,
      style: { maxWidth: '700px', zIndex: 9999 },
      anchorOrigin: {
        vertical: 'top',
        horizontal: 'right',
      },
      get domRoot() {
        return domRootRef.current;
      },
    },
    children
  );
};
